import { planningConstants as plans } from "../../../constants/planning";

const initialState = {
  loading: true,
  list: [],
  data: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case plans.GET_PLANNINGS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case plans.GET_PLANNING:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    default:
      return state;
  }
}
